import { render, staticRenderFns } from "./PurchaseRow.vue?vue&type=template&id=46bb722e&scoped=true&"
import script from "./PurchaseRow.vue?vue&type=script&lang=ts&"
export * from "./PurchaseRow.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseRow.vue?vue&type=style&index=0&id=46bb722e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bb722e",
  null
  
)

export default component.exports